module.exports = __webpack_public_path__ + "img/s-max.30e72e5f.png";